import React from 'react';

import { Chip, Link, Stack, Tooltip } from '@mui/material';

interface Props {
  regions?: Array<string> | null;
}

export function AgentHubCommissionRegions({ regions }: Props) {
  const regionList = regions ?? [];

  if (regionList.length === 0) {
    return (
      <Stack direction="row" alignItems="center" spacing={1}>
        <Chip label="All regions" variant="outlined" />
      </Stack>
    );
  }

  const regionsToShow = regionList.slice(0, 4);
  const remaining = regionList.length - regionsToShow.length;
  const remainingRegions = regionList.slice(regionsToShow.length);

  return (
    <Stack direction="row" alignItems="center" spacing={1}>
      {regionsToShow.map((region: string) => (
        <Chip key={region} label={region} variant="outlined" />
      ))}
      {remaining > 0 && (
        <Tooltip title={`${remainingRegions.join(' • ')}`}>
          <Link component="div" color="inherit" variant="caption">
            +{remaining} more
          </Link>
        </Tooltip>
      )}
    </Stack>
  );
}
